export default function TestimonialSection() {
  return (
    <section className="bg-background-200/60 py-20 md:py-28">
      <div className="px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-800 font-semibold tracking-tight">
            ( Trusted by Global Shoppers )
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex items-start gap-8">
            <div className="flex-shrink-0 mt-1">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span>4.9</span>
              </span>
            </div>

            <div>
              <blockquote className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed italic">
                &ldquo;The Mulebuy Spreadsheet guide completely transformed how I approach cross-border shopping. What used to take me hours of comparing products across different platforms is now organized in one clear system. The workflow explanations are practical and easy to follow for any skill level.&rdquo;
              </blockquote>

              <div className="mt-8 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20adult%20with%20genuine%20smile%20and%20casual%20style%20against%20soft%20sage%20green%20backdrop%2C%20warm%20natural%20window%20light%2C%20friendly%20approachable%20headshot%2C%20modern%20lifestyle%20portrait%2C%20relaxed%20authentic%20expression%2C%20shallow%20depth%20of%20field&width=200&height=200&seq=testimonial-avatar-v2-001&orientation=squarish"
                    alt="Mulebuy Spreadsheet user testimonial"
                    title="Happy Mulebuy Spreadsheet user"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-base font-semibold text-foreground-950">Alex Chen</p>
                  <p className="text-sm text-foreground-500">Cross-Border Shopping Enthusiast</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}